<template>
  <div class="main-container">
    <!-- breadcrumb start -->
    <breadcrumb :list="breadcrumbList" />
    <!-- breadcrumb end -->
    <tl-header type="h1" class="margin-t-l">Legacy Data</tl-header>
    <div class="row margin-t-m">
      <div class="col-3">
        <tl-select label="Select" labelText="name" :options="options" @change="onSelect($event)"></tl-select>
      </div>
      <div class="col-3">
        <tl-select label="Select month" :options="monthList" @change="onSelect($event)"></tl-select>
      </div>
    </div>
    <div class="row margintop-20">
      <div class="col-12">
        <download-button />
      </div>
      <div class="col-12">
        <upload />
      </div>
      <div class="col-12 margintop-30">
        <btn text="Add" type="secondary" @click="addFile()" />
      </div>
    </div>
    <data-table
      class="margintop-30"
      :columns="tableColumns"
      :tableData="tableData"
      :showinrow="false"
      :with-form="false"
    >
      <template v-slot:rowcontent="slotprops">
        <p v-if="slotprops.value.column.key=='documents'">
          <img src="@/assets/document.svg" alt />
          &nbsp;{{slotprops.value.record[slotprops.value.column.key]}}
        </p>
      </template>
    </data-table>
    <pop-up-message
      v-if="showSuccessMsg"
      :popupType="popupType"
      :message="popupMessage"
      btnText="Back to Legacy Data"
      @back="backfrompopup()"
    >
      <template v-slot:bottomContent v-if="isFileReplaced">
        <div class="popup-btn-group">
          <button
            class="btn-popup-secondary"
            type="button"
            @click="backfrompopup()"
          >Keep Both</button>
          <button class="btn-popup" type="button" @click="replaceFile">Replace</button>
        </div>
      </template>
    </pop-up-message>
    <bottom-action-container >
      <btn-grp slot="end">
        <btn text="Back" type="secondary" @click="cancel" />
        <btn text="Submit" type="primary" @click="save"></btn>
      </btn-grp>
    </bottom-action-container>
  </div>
</template>
<script>
export default {
  name: "LegacyData",
  data() {
    return {
      showSuccessMsg: false,
      isFileReplaced: true,
      popupType: "Warning",
      popupMessage:
        "A file named 'EmpCode_5468' under Salary Revision already exists.",
      breadcrumbList: [
        {
          name: "Organisation",
          url: `/dashboard/${this.$route.params.entity_index}/organisation`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/`
        },
        {
          name: "Legacy Data",
          url: ""
        }
      ],
      monthList: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      options: [
        {
          name: "Salary Register",
          value: "salaryRegister"
        },
        {
          name: "Salary Revision",
          value: "salaryRevision"
        },
        {
          name: "LOP/RLOP",
          value: "loprlop"
        },
        {
          name: "Loan",
          value: "loan"
        },
        {
          name: "Challan Mapping",
          value: "challanMapping"
        },
        {
          name: "Quaterly Returns",
          value: "quaterlyReturns"
        }
      ],
      tableColumns: [
        {
          label: "Category",
          key: "category"
        },
        {
          label: "Uploaded Date",
          key: "uploadDate"
        },
        {
          label: "Modified Date",
          key: "modifiedDate"
        },
        {
          label: "Modified By",
          key: "modifiedBy"
        },
        {
          label: "Documents",
          key: "documents"
        }
      ],
      tableData: [
        {
          category: "Salary Register",
          uploadDate: "03 Aug 2019",
          modifiedDate: "03 Aug 2019",
          modifiedBy: "Wayne Fowler",
          documents: "Jun 2019"
        },
        {
          category: "Salary Revision",
          uploadDate: "13 Sep 2019",
          modifiedDate: "13 Sep 2019",
          modifiedBy: "Blake Moran",
          documents: "Jun 2019"
        },
        {
          category: "LOP/RLOP",
          uploadDate: "20 Aug 2019",
          modifiedDate: "20 Aug 2019",
          modifiedBy: "Elijah Farmer",
          documents: "Jun 2019"
        }
      ]
    };
  },
  methods: {
    routeToMainStep() {},
    routeToSubStep() {},
    cancel() {},
    save() {
      this.showSuccessMsg = true;
      this.isFileReplaced = false;
      this.popupType = "Success";
      this.popupMessage = "Salary Register file submitted.";
    },
    onSelect(event) {
      //console.log(event);
    },
    addFile() {
      this.showSuccessMsg = true;
      this.isFileReplaced = true;
      this.popupType = "Warning";
      this.popupMessage =
        "A file named 'EmpCode_5468' under Salary Revision already exists.";
    },
    backfrompopup() {
      this.showSuccessMsg = false;
    },
    replaceFile() {
      this.popupType = "Success";
      this.isFileReplaced = false;
      this.popupMessage = "Salary Register file replaced.";
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
